<div
  [style.width.em]="element.hspWidth"
  [style.height.em]="element.hspHeight"
  [style.backgroundColor]="element.useUniqueColor ? element.hspColor : parentElement.hotspotGlobalColor"
  [style.opacity]="element.useUniqueColor ? (element.hspOpacity * 0.01) : (parentElement.hotspotGlobalOpacity * 0.01)"
>

</div>